var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
import apiClient from '@utils/api-client';
// ---------------------------------------------------------------------------
// Host surface — forwarded on every mint so a refresh keeps the claim
// ---------------------------------------------------------------------------
// Mirrors Rails `AiTokenIssuable::AI_TOKEN_SURFACES`. Rails defaults a missing
// or unknown value to `web`.
export const AI_TOKEN_SURFACES = ['web', 'ios_webview'];
let aiTokenSurface = null;
/**
 * Sets the surface sent with every token mint. Set by `mountChatWidget` from
 * the host's `surface` option; returns a closure that restores the previous
 * value. Values outside the allowlist are dropped rather than sent.
 */
export function configureAiTokenSurface(surface) {
    var _a;
    const previous = aiTokenSurface;
    aiTokenSurface = (_a = AI_TOKEN_SURFACES.find((allowed) => allowed === surface)) !== null && _a !== void 0 ? _a : null;
    return () => {
        aiTokenSurface = previous;
    };
}
/** The host surface this mount was configured with, or null (a plain web mount, or none given). */
export function getAiTokenSurface() {
    return aiTokenSurface;
}
// ---------------------------------------------------------------------------
// AI Token — POST /api/internal/ai/token (Rails, session auth)
// ---------------------------------------------------------------------------
// Every widget mint and refresh goes through here (useAiToken, and the 401
// retries in useBlockStream and useConfirmation), so this is the one place the
// surface has to be attached.
export function requestAiToken() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield apiClient.post('/api/internal/ai/token', undefined, aiTokenSurface ? { params: { surface: aiTokenSurface } } : undefined);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('[aiTokenApi] Error requesting AI token:', error);
            const errorMessage = error instanceof Error ? error.message : 'Failed to fetch AI token';
            return {
                error: {
                    message: errorMessage,
                    errors: error
                }
            };
        }
    });
}
